module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Maestro-944fe3b0a280986e0c3383228e8095d7.svg";